import { Binder,IBinding,BinderPropertyDescriptor,IConverter } from "./binding/binding";
import { HtmlBridge } from "./parser/bridges/htmlBridge";
import { View } from "./uiPatterns/mvvm/view";
import { ViewModel, ViewModelMessage } from "./uiPatterns/mvvm/viewmodel";
import { BindingConverterResolver } from "./parser/prototype/bindingPrototype";
import { ViewGenerator } from "./parser/viewGenerator";
import { ObservableArray,ObservableArrayChangeListenner,DelegatedObservableArrayChangeListenner } from "./observableList";
import { ComponentTagMappings } from "./parser/bridges/bridgeTypes/compoent";
import { AttachedPropertyValue, Component, ComponentView } from "./uiPatterns/component";
import { SamePropertyNamesBinder } from "./parser/bridges/utilities";
import { distinct } from "src/common/utilities";

class BinderConfigurator{
    private static _existingConverterFunctionNames:string[];
    public pushConverterRepository(repo:object){
        BindingConverterResolver.converterRepository.push(repo);
        BinderConfigurator.updateListOfAvailableFunctions();
    }
    private static updateListOfAvailableFunctions(){
        let q = [...BindingConverterResolver.converterRepository];
        let functions = q.flatMap(x=>this.getFunctions(x));
        let objectFunctions = this.getFunctions(new Object());
        let result = distinct(functions).filter(x=>objectFunctions.indexOf(x)==-1);
        BinderConfigurator._existingConverterFunctionNames = result;
    }
    public static GetAllConverterFunctionNames():string[]{
        return BinderConfigurator._existingConverterFunctionNames;
    }

    private static getFunctions(o:object):string[]{
        let result = [];
        let q=[o];
        while(q.length>0){
            let x = q.shift();
            let functions = Object.getOwnPropertyNames(x).filter(function (p) {
                return typeof x[p] === 'function';
            });
            let proto = Object.getPrototypeOf(x);
            if(proto!=null){
                q.push(proto)
            }
            result.push(...functions);
        }
        return result;
    }
}

export {ComponentTagMappings}
export {Binder,IBinding,BinderPropertyDescriptor,IConverter}
export {View,ViewModel,HtmlBridge}
export {BinderConfigurator}
export {ViewGenerator,ViewModelMessage,SamePropertyNamesBinder}
export {ObservableArray,ObservableArrayChangeListenner,DelegatedObservableArrayChangeListenner}
export {AttachedPropertyValue,Component,ComponentView}